(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "react-router", "react-spring", "react-use-gesture", "../../hooks", "../ViewElements/ViewElementAnimation", "../ViewElements/ViewGlobalStyle", "react/jsx-runtime"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("react-router"), require("react-spring"), require("react-use-gesture"), require("../../hooks"), require("../ViewElements/ViewElementAnimation"), require("../ViewElements/ViewGlobalStyle"), require("react/jsx-runtime"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactRouter, global.reactSpring, global.reactUseGesture, global.hooks, global.ViewElementAnimation, global.ViewGlobalStyle, global.jsxRuntime);
    global.ViewComponentSpring = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _reactRouter, _reactSpring, _reactUseGesture, _hooks, _ViewElementAnimation, _ViewGlobalStyle, _jsxRuntime) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ViewComponentSpring = void 0;
  _propTypes = _interopRequireDefault(_propTypes);
  var _excluded = ["duration", "delay", "viewType"];

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

  function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

  function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

  function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

  var callbackCancel = null;
  var callbackRestore = null;
  var ViewComponentSpring = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
    var $duration = _ref.duration,
        $delay = _ref.delay,
        $viewType = _ref.viewType,
        props = _objectWithoutProperties(_ref, _excluded);

    var _useContext = (0, _react.useContext)(_reactRouter.__RouterContext),
        routerIndex = _useContext.routerIndex;

    var link = (0, _hooks.useLink)();
    var history = (0, _reactRouter.useHistory)();

    var _usePreventBackward = (0, _hooks.usePreventBackward)(false),
        _usePreventBackward2 = _slicedToArray(_usePreventBackward, 1),
        prevent = _usePreventBackward2[0];

    var premount = (0, _hooks.usePremount)();

    var _useSpring = (0, _reactSpring.useSpring)(function () {
      return {
        x: 0,
        y: 0
      };
    }),
        _useSpring2 = _slicedToArray(_useSpring, 2),
        x = _useSpring2[0].x,
        set = _useSpring2[1]; // Set the drag hook and define component movement based on gesture data


    var bind = (0, _reactUseGesture.useDrag)(function (_ref2) {
      var _ref$current;

      var event = _ref2.event,
          down = _ref2.down,
          _ref2$movement = _slicedToArray(_ref2.movement, 1),
          mx = _ref2$movement[0],
          _ref2$direction = _slicedToArray(_ref2.direction, 1),
          dx = _ref2$direction[0],
          velocity = _ref2.velocity;

      var targetElement = event.target;
      var timeout = $duration + $delay; // Prevents execution if the event target is a subroute.

      if (targetElement.closest('.view') !== ref.current) return; // Prevent execution if classname is included to prevent drag.

      if (targetElement.closest('.view-drag-dismiss')) return;
      var nextSibling = ((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.nextSibling) || null;
      var isPass = routerIndex || nextSibling; // If no next sibling are exist, execute premount.

      if (!nextSibling) premount();
      var x = 0;

      if (down) {
        // If there is no element sibling or if prevent is set, define x as 1/3.
        x = mx < 0 ? 0 : !routerIndex && (!nextSibling || prevent) ? mx / 3 : mx;
        x = parseFloat(parseFloat(x).toFixed(1));
      } else if (mx > window.innerWidth / 2 && isPass) {
        x = window.innerWidth;
      } else if (velocity > 1 && dx === 1 && isPass) {
        x = window.innerWidth;
      }

      if (down && callbackCancel) {
        clearTimeout(callbackCancel);
        callbackCancel = null;
      }

      if (down && callbackRestore) {
        clearTimeout(callbackRestore);
        callbackRestore = null;
      }

      if (down) {
        var _ref$current2, _ref$current3;

        if (!((_ref$current2 = ref.current) !== null && _ref$current2 !== void 0 && _ref$current2.hasAttribute('data-drag'))) (_ref$current3 = ref.current) === null || _ref$current3 === void 0 ? void 0 : _ref$current3.setAttribute('data-drag', true);
        if (!(nextSibling !== null && nextSibling !== void 0 && nextSibling.hasAttribute('data-drag'))) nextSibling === null || nextSibling === void 0 ? void 0 : nextSibling.setAttribute('data-drag', true);
      } else {
        callbackCancel = setTimeout(function () {
          var _ref$current4, _ref$current5;

          if ((_ref$current4 = ref.current) !== null && _ref$current4 !== void 0 && _ref$current4.hasAttribute('data-drag')) (_ref$current5 = ref.current) === null || _ref$current5 === void 0 ? void 0 : _ref$current5.removeAttribute('data-drag');
          if (nextSibling !== null && nextSibling !== void 0 && nextSibling.hasAttribute('data-drag')) nextSibling === null || nextSibling === void 0 ? void 0 : nextSibling.removeAttribute('data-drag');
        }, timeout);
      }

      if (!down && x > 0 && isPass) {
        if (prevent) x = 0;

        if (prevent) {
          history.goBack();
        } else {
          link.goBackView();
        }

        callbackRestore = setTimeout(function () {
          set.start({
            x: 0,
            immediate: true
          });
        }, timeout);
      }

      set.start({
        x: x,
        immediate: down
      });
    }, {
      initial: function initial() {
        return [x.get()];
      },
      axis: 'x',
      threshold: 20
    });

    var viewProps = _objectSpread(_objectSpread({}, bind()), {}, {
      style: {
        x: x
      },
      className: 'view ' + props.className
    });

    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ViewGlobalStyle.ViewGlobalStyle, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ViewElementAnimation.ViewElementAnimation, _objectSpread(_objectSpread({
        ref: ref
      }, props), {}, {
        $duration: $duration,
        $delay: $delay,
        $viewType: $viewType
      }, viewProps))]
    });
  });
  _exports.ViewComponentSpring = ViewComponentSpring;
  ViewComponentSpring.propTypes = {
    className: _propTypes.default.string,
    duration: _propTypes.default.number,
    delay: _propTypes.default.number,
    viewType: _propTypes.default.string
  };
});